export { default } from './BudgetFriendlyCarousel';
